import { StyledTable } from '@/shared/ui/tables'
import React, { Component } from 'react'
import {
    Alert,
    Autocomplete,
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Paper,
    TableCell,
    TableContainer,
    TableRow,
    Tabs,
    TextField,
} from '@mui/material'
import { LoadingDefault } from '@/shared/ui/loading'
import DefDossierDefFieldSettings from './DefDossierDefFieldSettings/DefDossierDefFieldSettings'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import AddDisplayByDataFieldModal from './AddDisplayByDataFieldModal'
import ObjectCreatedInfo from '@/shared/composed-ui/object-created-info/ObjectCreatedInfo'
import AdminQuickEditMenu from '@/feature/admin/quick-edit/AdminQuickEditMenu'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { StyledButton } from '@/shared/ui/buttons'
import { StyledVerticalTab } from '@/shared/ui/tabs'
import { TabPanel } from '@/shared/ui/tab-panel'
import { FormInputLabel, selectionControlLabelProps } from '@/shared/ui/input'
import { autocompleteGroupedSlotProps } from '@/shared/ui/styles'

class DefDossierDefFieldForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activeDefField: false,
            defDossier: this.props.defDossier,
            submitting: false,
            showDisplayQuestion: false,
            isExisting: this.props.item && this.props.item.id > 0,
            errors: false,
            dataFields: [],
            concerningDisplayItems: [],
            displayPositions: [],
            baseFields: [],
            loadingBaseFields: true,
            infoItem: null,
            locked: this.props.item?.locked,
            item: this.props.item
                ? {
                      name: this.props.item.name,
                      defField: this.props.item.def_field.id,
                      def_field: this.props.item.def_field,
                      obligatory: this.props.item.obligatory,
                      locked: this.props.item.locked,
                      locked_description:
                          this.props.item?.locked_description ?? '',
                      settings:
                          this.props.item &&
                          this.props.item.settings &&
                          !Array.isArray(this.props.item.settings)
                              ? this.props.item.settings
                              : {},
                  }
                : {
                      settings: {},
                  },
            activeTab: 'general',
        }

        this.handleErrors = this.handleErrors.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        this.onSettingsChange = this.onSettingsChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.handleBaseFieldChange = this.handleBaseFieldChange.bind(this)
        this.submitDataField = this.submitDataField.bind(this)
    }

    /**
     * @param response
     * @returns {boolean}
     */
    hasFormErrors(response) {
        if (
            response.response.status === 400 &&
            response.response.data &&
            response.response.data.errors
        ) {
            return true
        }

        return false
    }

    handleSuccess(showDisplayQuestion, item, originalName) {
        if (showDisplayQuestion === true) {
            if (originalName) {
                item.name = originalName
            }
            this.setState({
                showDisplayQuestion: true,
                displayItem: item,
            })

            if (item && this.props.handleSuccess) {
                this.props.handleSuccess(item.id)
            }
        } else {
            this.setState({
                submitting: false,
                item: {},
                errors: false,
            })

            this.props.onClose(true)

            if (item && this.props.handleModification) {
                this.props.handleModification(item.id)
            }
        }
    }

    handleErrors(response) {
        if (!this.hasFormErrors(response)) {
            this.setState({
                submitting: false,
                errors: {
                    generic: this.props.kedo.t('Something went wrong'),
                },
            })
        }
        this.setState({
            submitting: false,
            errors: response.response.data.errors,
        })
    }

    handleCheck(event) {
        let item = this.state.item
        item[event.target.name] = event.target.checked
        this.setState({ item: item })
    }

    handleChange(event) {
        let item = this.state.item
        item[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    async submitDataField() {
        let errors = {}

        if (!this.state?.item?.name || !this.state.item.defField) {
            if (
                this.state?.item &&
                (!this.state?.item?.name || this.state.item?.name.length <= 0)
            ) {
                errors['name'] = this.props.kedo.t('This is a required field')
            }
            if (
                this.state.item &&
                (!this.state.item.defField ||
                    this.state.item.defField.length <= 0)
            ) {
                errors['defField'] = this.props.kedo.t(
                    'This is a required field'
                )
            }

            this.setState({ errors: errors })
            return
        }

        this.setState({
            submitting: true,
            errors: false,
        })

        let item = {
            obligatory: this.state.item.obligatory,
            defField: this.state.item.defField,
            name: this.state.item.name.replace(/(\s|\W)+/g, '_'),
            defDossier: this.state.defDossier,
            settings: this.state.item.settings,
            locked: this.state.item.locked,
            locked_description: this.state.item.locked_description,
        }
        let originalName = this.state.item.name
        if (this.props.item && this.props.item.id) {
            item.id = this.props.item.id
            item.uuid = this.props.item.uuid
        }

        if (!this.state.item.locked && this.state.locked) {
            await this.props.kedo
                .api()
                .get(
                    this.props.kedo.api().getDefDossierDefFieldEndpoint() +
                        '/' +
                        item.id +
                        '/lock'
                )
        }

        if (item.id) {
            this.props.kedo
                .api()
                .put(
                    this.props.kedo.api().getDefDossierDefFieldEndpoint() +
                        '/' +
                        item.id,
                    item
                )
                .then(() => this.handleSuccess(false, item))
                .catch((errResponse) => this.handleErrors(errResponse))
        } else {
            item.environment = this.props.kedo.env().getEnvironment().id
            item.defDossier = parseInt(this.state.defDossier)
            item.uuid = this.props.kedo.utils().uuidv4()

            this.props.kedo
                .api()
                .post(
                    this.props.kedo.api().getDefDossierDefFieldEndpoint(),
                    item
                )
                .then((successResponse) => {
                    item.id = successResponse.data.id
                    this.handleSuccess(true, item, originalName)
                })
                .catch((errResponse) => this.handleErrors(errResponse))
        }
    }

    fetchBaseFields() {
        let params = {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 500,
            },
        }

        if (
            this.props.item &&
            this.props.item.id > 0 &&
            this.props.item.def_field
        ) {
            params.params.type = this.props.item.def_field.type
        }

        this.setState({ loadingBaseFields: true })
        this.props.kedo
            .api()
            .getCached(this.props.kedo.api().getDefFieldEndpoint(), params)
            .then((response) =>
                this.setState({
                    baseFields: response.data.results,
                    loadingBaseFields: false,
                })
            )
    }

    isTextType(item) {
        if (item.type === 'url' || item.type === 'email') {
            return true
        } else if (item.type === 'text' || item.type === 'textarea') {
            return true
        }
    }

    getBaseFieldGroup(item) {
        const kedo = this.props.kedo
        if (this.isTextType(item)) {
            return kedo.t('Text')
        }
        if (item.type === 'date' || item.type === 'datetime') {
            return kedo.t('Date')
        }
        if (item.type === 'list' || item.type === 'tree') {
            return kedo.t('List')
        }
        return kedo.t('Other')
    }

    getBaseFieldOptions() {
        const fields = this.state.baseFields
        const text = fields.filter((item) => this.isTextType(item))
        const date = fields.filter(
            (item) => item.type === 'date' || item.type === 'datetime'
        )
        const list = fields.filter(
            (item) => item.type === 'list' || item.type === 'tree'
        )
        const other = fields.filter(
            (item) =>
                !this.isTextType(item) &&
                item.type !== 'date' &&
                item.type !== 'datetime' &&
                item.type !== 'list' &&
                item.type !== 'tree'
        )
        return [...text, ...date, ...list, ...other]
    }

    getSelectedBaseField() {
        const defFieldId = this.state.item?.defField
        if (defFieldId == null || defFieldId === '') {
            return null
        }
        return (
            this.state.baseFields.find(
                (item) =>
                    item.id === defFieldId ||
                    item.id === parseInt(defFieldId, 10)
            ) || null
        )
    }

    handleBaseFieldChange(_event, option) {
        const item = this.state.item
        item.defField = option ? option.id : ''
        this.setState({ item })
    }

    getDateSettings(settings) {
        if (!settings) {
            return []
        }
        let labels = []
        labels.push({ name: 'restriction', value: settings.restriction })

        return labels
    }

    getTextSettings(settings) {
        if (!settings) {
            settings = {}
        }

        let labels = []
        labels.push({ name: 'regex', value: settings.regex })
        labels.push({ name: 'size', value: settings.size })

        return labels
    }

    onSettingsChange(name, value) {
        let item = this.state.item

        if (typeof item.settings !== 'object' || item.settings === null) {
            item.settings = {}
        }
        item.settings[name] = value

        this.setState({ item: item })
    }

    getDefDossierDefFieldSettings(item) {
        return (
            <DefDossierDefFieldSettings
                onSettingsChange={this.onSettingsChange}
                kedo={this.props.kedo}
                item={item}
                defDossier={this.state.defDossier}
            />
        )
    }

    getCurrentDefFieldSetting(defFieldId) {
        let defField = this.state.baseFields.find(
            (item) => item.id === parseInt(defFieldId)
        )
        if (!defField || !defField.type) {
            return ''
        }

        let fieldType = defField.type
        let settings = defField.settings

        let settingItems = []
        switch (fieldType) {
            case 'date':
            case 'datetime':
                settingItems = this.getDateSettings(settings)
                break
            case 'text':
                settingItems = this.getTextSettings(settings)
                break
            default:
                return ''
        }

        return (
            <div>
                <h5>{this.props.kedo.t('Additional information')}</h5>
                {settingItems && settingItems.length > 0 ? (
                    settingItems.map((item, index) => (
                        <FormControl key={index} fullWidth sx={{ mt: 2 }}>
                            <FormInputLabel htmlFor={`field-${index}`}>
                                {item.name}
                            </FormInputLabel>
                            <TextField
                                slotProps={{
                                    htmlInput: { id: `field-${index}` },
                                }}
                                disabled
                                id={`field-${index}`}
                                size="small"
                                name={item.name}
                                value={
                                    item.value ||
                                    this.props.kedo.t('Not indicated')
                                }
                            />
                        </FormControl>
                    ))
                ) : (
                    <Alert security={'info'}>
                        {this.props.kedo.t('No data available')}
                    </Alert>
                )}
            </div>
        )
    }

    fetchDataField() {
        const kedo = this.props.kedo

        kedo.api()
            .get(kedo.api().getDefDossierDefFieldEndpoint(this.props.item.id))
            .then((response) => {
                this.setState({ infoItem: response.data })
            })
    }

    fetchConcerningDisplayItems(dataFieldId) {
        const kedo = this.props.kedo

        if (this.props?.item?.def_dossier_id) {
            kedo.api()
                .get(kedo.api().getDisplayPositionEndpoint(), {
                    params: { defDossier: this.props.item.def_dossier_id },
                })
                .then((response) => {
                    this.setState({
                        displayPositions: response?.data?.results ?? [],
                    })

                    kedo.api()
                        .get(kedo.api().getDisplayItemEndpoint(), {
                            params: { defDossierDefFieldId: dataFieldId },
                        })
                        .then((response) => {
                            this.setState({
                                concerningDisplayItems:
                                    response?.data?.results ?? [],
                            })
                        })
                })
        }
    }

    componentDidMount() {
        this.fetchBaseFields()
        if (this.props?.item?.id) {
            this.fetchDataField()
            this.fetchConcerningDisplayItems(this.props.item.id)
        }
    }

    render() {
        const kedo = this.props.kedo
        if (this.state.showDisplayQuestion) {
            return (
                <AddDisplayByDataFieldModal
                    kedo={kedo}
                    item={this.state.displayItem}
                    onClose={() => this.handleSuccess()}
                />
            )
        }

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'xl'}
                topAlign={true}
                fullWidth
                title={
                    <>
                        {this.props.item && this.props.item.name
                            ? this.props.kedo.t('Edit data field') +
                              ': ' +
                              this.props.item.name
                            : this.props.kedo.t('New data field')}
                        {this.props.item ? (
                            <Box
                                component="small"
                                sx={{ color: 'text.disabled' }}
                            >
                                {' '}
                                ({this.props.item.id})
                            </Box>
                        ) : null}
                    </>
                }
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true, dense: true }}
                actions={
                    <>
                        <StyledButton
                            disabled={this.state.loading}
                            onClick={this.submitDataField}
                            sx={{ '& svg': { mr: 1 } }}
                        >
                            {this.state.submitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            {this.props.kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            disabled={this.state.loading}
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Grid container>
                    <Grid
                        size={3}
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                        <Tabs
                            value={this.state.activeTab}
                            orientation="vertical"
                            onChange={(event, newValue) =>
                                this.setState((prevState) => ({
                                    ...prevState,
                                    activeTab: newValue,
                                }))
                            }
                            sx={{
                                '& .MuiTabs-indicator': {
                                    display: 'none',
                                },
                            }}
                        >
                            <StyledVerticalTab
                                label={this.props.kedo.t('Default')}
                                value="general"
                            />
                            <StyledVerticalTab
                                label={this.props.kedo.t('Misc')}
                                value="misc"
                            />
                            {this.props.item && this.props.item.id ? (
                                <StyledVerticalTab
                                    label={
                                        <>
                                            <span>
                                                {this.props.kedo.t(
                                                    'Display fields'
                                                )}{' '}
                                            </span>
                                            <span
                                                className={'badge badge-info'}
                                            >
                                                {
                                                    this.state
                                                        .concerningDisplayItems
                                                        .length
                                                }
                                            </span>
                                        </>
                                    }
                                    value="displayitems"
                                    sx={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: 1,
                                        width: '100%',
                                        justifyContent: 'space-between',
                                    }}
                                />
                            ) : null}
                            {this.props.item && this.props.item.id ? (
                                <StyledVerticalTab
                                    label={this.props.kedo.t('Info')}
                                    value="info"
                                />
                            ) : null}
                        </Tabs>
                    </Grid>
                    <Grid size={9}>
                        <TabPanel value={this.state.activeTab} index="general">
                            <h3>
                                {kedo.t('Default')}{' '}
                                {kedo.t('Settings').toLowerCase()}
                            </h3>
                            <FormControl fullWidth>
                                <FormInputLabel
                                    className={'required'}
                                    htmlFor="field-name"
                                >
                                    {kedo.t('Name')}
                                </FormInputLabel>
                                <TextField
                                    slotProps={{
                                        htmlInput: { id: 'field-name' },
                                    }}
                                    id="name"
                                    name="name"
                                    size="small"
                                    value={this.state.item.name}
                                    onChange={this.handleChange}
                                    error={Boolean(this.state.errors?.name)}
                                    helperText={this.state.errors?.name}
                                />
                            </FormControl>
                            <FormControl
                                fullWidth
                                size="small"
                                error={Boolean(this.state.errors?.defField)}
                                sx={{ mt: 2 }}
                            >
                                <FormInputLabel
                                    className="required"
                                    htmlFor="def-field-select"
                                >
                                    {kedo.t('Base field')}
                                </FormInputLabel>

                                <Autocomplete
                                    id="def-field-select"
                                    size="small"
                                    autoHighlight
                                    slotProps={autocompleteGroupedSlotProps}
                                    options={this.getBaseFieldOptions()}
                                    groupBy={(option) =>
                                        this.getBaseFieldGroup(option)
                                    }
                                    getOptionLabel={(option) =>
                                        option?.name || ''
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                    }
                                    getOptionDisabled={(option) =>
                                        Boolean(this.props.item?.name) &&
                                        (option.type === 'list' ||
                                            option.type === 'tree')
                                    }
                                    value={this.getSelectedBaseField()}
                                    onChange={this.handleBaseFieldChange}
                                    loading={this.state.loadingBaseFields}
                                    disabled={
                                        this.state.isExisting &&
                                        this.props.item?.def_field?.type ===
                                            'list'
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            placeholder={kedo.t(
                                                'Choose an option'
                                            )}
                                            error={Boolean(
                                                this.state.errors?.defField
                                            )}
                                        />
                                    )}
                                />

                                {this.state.errors?.defField && (
                                    <FormHelperText>
                                        {this.state.errors.defField}
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <Box mt={2}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={
                                                this.state.item?.obligatory ||
                                                false
                                            }
                                            onChange={this.handleCheck}
                                            name="obligatory"
                                        />
                                    }
                                    label={this.props.kedo.t('Required')}
                                    {...selectionControlLabelProps}
                                />
                            </Box>
                            <Box>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            checked={
                                                this.state.item?.locked || false
                                            }
                                            onChange={this.handleCheck}
                                            name="locked"
                                        />
                                    }
                                    label={this.props.kedo.t('Lock')}
                                    {...selectionControlLabelProps}
                                />
                            </Box>
                            {this.state.item?.locked && (
                                <Box mb={2}>
                                    <FormControl fullWidth>
                                        <FormInputLabel htmlFor="locked_description">
                                            {`${kedo.t('Lock')} ${kedo.t(
                                                'Description'
                                            )}`}
                                        </FormInputLabel>
                                        <TextField
                                            id="locked_description"
                                            multiline
                                            rows={3}
                                            fullWidth
                                            name="locked_description"
                                            value={
                                                this.state.item
                                                    .locked_description || ''
                                            }
                                            onChange={this.handleChange}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                </Box>
                            )}
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="misc">
                            {this.getDefDossierDefFieldSettings(
                                this.state.item
                            )}
                            {this.getCurrentDefFieldSetting(
                                this.state.item.defField
                            )}
                        </TabPanel>
                        {this.props.item && this.props.item.id ? (
                            <TabPanel value={this.state.activeTab} index="info">
                                <h3>{kedo.t('Info')}</h3>
                                {this.state.infoItem ? (
                                    <ObjectCreatedInfo
                                        kedo={kedo}
                                        item={this.state.infoItem}
                                    />
                                ) : null}
                            </TabPanel>
                        ) : null}
                        {this.props.item && this.props.item.id ? (
                            <TabPanel
                                value={this.state.activeTab}
                                index={'displayitems'}
                            >
                                <Box sx={{ mt: 1 }}>
                                    <TableContainer component={Paper}>
                                        <StyledTable size="small" hover striped>
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <h3>
                                                        {kedo.t(
                                                            'Display fields'
                                                        )}
                                                    </h3>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Id')}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Name')}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Position')}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('View')}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontWeight: 'bold' }}
                                                >
                                                    {kedo.t('Edit')}
                                                </TableCell>
                                            </TableRow>
                                            {this.state.concerningDisplayItems.map(
                                                (ddiItem) => {
                                                    return (
                                                        <TableRow
                                                            key={ddiItem.id}
                                                        >
                                                            <TableCell>
                                                                {ddiItem.id}
                                                            </TableCell>
                                                            <TableCell>
                                                                {kedo.translateItem(
                                                                    ddiItem,
                                                                    'displayitem'
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                {this.state
                                                                    .displayPositions
                                                                    .length >
                                                                    0 &&
                                                                    (() => {
                                                                        const pos =
                                                                            this.state.displayPositions.find(
                                                                                (
                                                                                    d
                                                                                ) =>
                                                                                    d.id ===
                                                                                    ddiItem.display_position_id
                                                                            )
                                                                        return pos
                                                                            ? kedo.translateItem(
                                                                                  pos,
                                                                                  'displayposition'
                                                                              )
                                                                            : null
                                                                    })()}
                                                            </TableCell>
                                                            <TableCell>
                                                                {kedo.t(
                                                                    ddiItem.view
                                                                )}
                                                            </TableCell>
                                                            <TableCell>
                                                                <AdminQuickEditMenu
                                                                    className={
                                                                        'inner-edit'
                                                                    }
                                                                    kedo={kedo}
                                                                    item={
                                                                        ddiItem
                                                                    }
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            )}
                                        </StyledTable>
                                    </TableContainer>
                                </Box>
                            </TabPanel>
                        ) : null}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }
}

export default DefDossierDefFieldForm
